import RecoveryVerification from './RecoveryVerification'
export default RecoveryVerification
